
import React, { useState, useEffect, useContext } from 'react'
import { Tag, message, Icon, Badge } from 'antd'
import env from '../environments';
import GlobalStateContext from '../context';
import Rider from './Rider';
import * as _ from 'lodash'
import PublicStreams from './PublicStreams';
import PaymentWebService from '../classes/PaymentWebService';
import WaitingForStream from '../pages/protected/streams/components/WaitingForStream';
import { STREAM_STATUS_DONE, EVT_RECORD_VIEW, PAYMENT_PAYSTACK, PAYMENT_FLUTTERWAVE, STREAM_STATUS_INACTIVE, STREAM_FILE_STATUS_READY, STREAM_STATUS_ACTIVE, STREAM_SOURCE_URL } from '../constants';
import FollowButton from './FollowButton';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import Loading from './Loading';
import { isSafari } from 'react-device-detect';
import { genrateAvatarImageLink, useQuery } from '../utils';
import Comments from './comment/Comments';
import { PayTicketFlow } from './PayTicketFlow';
import { Eye } from 'lucide-react';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';



// type VideoPartProps = { part:object, onClick:Function}
// type VideoPartsProps = { parts:object[],callback:Function}


export function VideoPart(props) {
    return (

        <div className='part' onClick={ev => props.onClick(props.part)}>
            <div className='part-thumbnail'></div>
            <div className='part-label'>{props.part.name}</div>
        </div>
    )
}




export function VideoParts(props) {

    return (
        <div className='video-parts'>

            {
                props.parts.length > 0 && props.parts.map(part => <VideoPart key={part.resource_id} part={part} onClick={props.callback} />)
            }


        </div>
    )
}

function SignalActive({ params }) {
    const { recordView, handleError, onBuffer, playbackUrl, snapshot } = params;




    return !isSafari ?

        <ReactPlayer
            className="aspect-w-16 aspect-h-9 player-content"
            playsinline
            playing
            controls
            onStart={recordView}
            onError={handleError}
            onBuffer={onBuffer}
            width="100%"
            loop
            // height="80vh"

            url={playbackUrl}
            style={{ maxHeight: "500px", background: "#000" }}
        />
        :
        <ReactPlayer

            className="aspect-w-16 aspect-h-9 player-content"
            playsinline
            playing
            controls
            onStart={recordView}
            onBuffer={onBuffer}
            width="100%"
            onError={handleError}
            loop
            // height="80vh"

            url={playbackUrl}
            style={{ maxHeight: "500px", background: "#000" }}
            config={{
                file: {
                    forceHLS: isSafari,
                    forceVideo: !isSafari,
                    hlsVersion: '0.12.4',
                    attributes: {
                        poster: snapshot,
                        disablePictureInPicture: true
                    }
                }
            }}
        />
}

function NoSignal({ item }) {


    return <WaitingForStream
        className="card-img-top   aspect-w-16 aspect-h-9 bg-gray-600 br-10 text-white"
        backdrop={item?.image}
        style={{ border: 'none' }}
        width={"none"}
        height={"none"}
        text={item.status == STREAM_STATUS_INACTIVE ? <div className='text-lg text-white'>Livestream not started</div> : <div className='text-lg text-white'>Event has Ended</div>}
        description={item.status == STREAM_STATUS_INACTIVE ? <div className='text-gray-400'>Video will be live when event starts</div> : <div className='text-gray-400'>You should have been here earlier</div>}
    />

}

export default function ViewPublicStream(props) {

    const { streamingServer } = env.app.api;
    const { live } = streamingServer.apps

    let { item, isEmbeded } = props;

    const [state, dispatch] = useContext(GlobalStateContext)
    const { io, user } = state;
    const [isLoading, setIsLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [shouldMakePayment, setShouldMakePayment] = useState(false);
    const id = item.id || item._id;
    const urlQuery = useQuery()
    const [playbackUrl, setPlaybackUrl] = useState(item.video)
    const [views, setViews] = useState(item.views)
    const [watching, setWatching] = useState(0)
    const [limitDescription, setLimitDescription] = useState(true)
    const selectedPart = urlQuery.get("part")
    const fallbackImageUrl = genrateAvatarImageLink(item?.user?.name)

    // const lnk = "http://localhost:8000/live/a80c60f5-49ad-4db8-8a3f-1bca1f866b0c/master.m3u8"

    const snapshot = item.image;


    const handleDonePublish = (streamToken) => {
        // message.info("Stream ended.")
    }
    const handleTermination = (reason) => {
        message.error(`Stream Terminated. ${reason}`)
    }

    const onViewCount = (count) => {
        setViews(count);
    }
    const onWachingCount = (count) => {
        setWatching(count);
    }
    const handleError = (err) => {
        setErrorMsg("Connection error. Check stream source if you entered the right destination url")
        setPlaybackUrl(`${playbackUrl}`)
    }
    const onBuffer = (err) => {
        setErrorMsg("[x] On Buffer")

    }

    const recordView = () => {

        // const webservice = new StreamWebService();
        // if (item.user) {
        //     if (user.id === item.user.id) {
        //         webservice.logView(id);
        //     }
        // } else {
        //     webservice.logView(id);
        // }
        io.emit(EVT_RECORD_VIEW, id, user.id);

    }

    const confirmPayment = () => {
        if (!user) {
            setShouldMakePayment(true)
        } else {

            const service = new PaymentWebService();
            service.confirm({
                entity: id,
                amount: item.ppv_value
            }).then(res => setShouldMakePayment(!res.data))
                .catch(reason => {
                    setShouldMakePayment(true)
                    message.info("You may be required to login")
                })
        }
    }


    const cleanUp = () => {
        io.emit(`leave_room`, `${item.id}.watching`);
        io.removeAllListeners(`${item.token}_done_publish`);
        io.removeAllListeners(`${item.token}_terminated`);
        io.removeAllListeners(`view_count_${item.id}`);
        io.removeAllListeners(`${item.id}.watching`);
    }


    useEffect(() => {
        console.log(`watching.${item.id}`, item.video)
        io.on(`${item.token}_done_publish`, handleDonePublish)
        io.on(`${item.token}_terminated`, handleTermination);
        io.on(`view_count_${item.id}`, onViewCount);
        io.on(`${item.id}.watching`, onWachingCount);
        io.emit(`join_room`, `${item.id}.watching`); //join watch room
        item.ppv_value > 0.00 && confirmPayment(); //confirm payment if the stream isn't free
        return cleanUp;

    }, [item.id]);

    useEffect(() => {
        if (selectedPart) {
            const target = item.parts.find(part => part.resource_id == selectedPart)
            if (target) {
                console.log(playbackUrl);
                setPlaybackUrl(target.path)
            }

        }

    }, [selectedPart])
    useEffect(() => {
        console.log(playbackUrl);


    }, [playbackUrl])


    const styles = {
        bodyContent: {
            display: "flex",
            justifyContent: "space-between"
        }
    }

    return (


        <Loading loading={isLoading}>
            <Rider steps={state.introSteps.viewStream} />
            <div className="row">
                {/* <div className="col-12 m-t-10">
                    <h4>{item.title} {item.status =="1" && <Badge status="error" />}</h4>
                </div> */}


            </div>
            <div className="row m-0 m-t-20">

                <div className="col-md-12 col-sm-12 col-lg-9  m-b-10">
                    <div className="card player-container bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
                        {(shouldMakePayment && user._id != item.user?._id) ?

                            <WaitingForStream
                                backdrop={item?.image}
                                className="card-img-top   aspect-w-16 aspect-h-9 bg-blue-100 br-10"
                                text={
                                    <>
                                        <p className="text-lg m-1"> Ticket required </p>

                                        {<div>

                                            <PayTicketFlow amount={item.ppv_value}
                                                payment_method={PAYMENT_PAYSTACK}
                                                entity={item}
                                                redirect_url={window.location}
                                                showButton={true} />

                                        </div>
                                        }
                                    </>
                                } />

                            :

                            ((item?.status == STREAM_STATUS_ACTIVE && item?.source == STREAM_SOURCE_URL) || item?.is_streaming == STREAM_STATUS_ACTIVE || item?.file_status == STREAM_FILE_STATUS_READY) ?
                                <SignalActive
                                    params={{ recordView, handleError, onBuffer, playbackUrl, snapshot }}
                                /> :
                                <NoSignal item={item} />

                        }
                        <div className='p-4 sm:p-6'>

                            <div className="">
                                <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4 mb-6">
                                    <div className='flex gap-4'>
                                        <div className="flex-shrink-0">
                                            <object data={item?.user?.picture} type="image/jpeg" className="w-12 h-12 rounded-full bg-gray-100 shadow-sm object-cover">
                                                <img src={fallbackImageUrl} alt="Name" className="w-full h-full rounded-full object-cover" />
                                            </object>
                                        </div>
                                        <div className='flex flex-col'>
                                            <div className="flex items-center gap-3 mb-1">
                                                <h1 className="font-bold text-xl sm:text-2xl text-gray-900 leading-tight">{item.title}</h1>
                                                {item.status == "1" && (
                                                    <span className="flex h-3 w-3 relative">
                                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                                        <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500"></span>
                                                    </span>
                                                )}
                                            </div>
                                            <div className="flex items-center gap-2 text-sm text-gray-500">
                                                <Link to={`/channel/${item.user?._id}`} className="font-medium text-gray-900 hover:text-blue-600 transition-colors">
                                                    {item.user?.name}
                                                </Link>
                                                <span>•</span>
                                                <span>{moment(item.createdAt).fromNow()}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-4">
                                        <div className="flex items-center gap-4 bg-gray-50 px-4 py-2 rounded-lg border border-gray-100">
                                            <div className="flex items-center gap-2 text-gray-600">
                                                <Eye size={16} />
                                                <span className="text-sm font-medium">{views || 0} views</span>
                                            </div>
                                            {watching > 1 && (
                                                <>
                                                    <div className="w-px h-4 bg-gray-300"></div>
                                                    <span className="text-xs font-medium text-red-500 flex items-center gap-1">
                                                        <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                                                        {watching || 0} watching
                                                    </span>
                                                </>
                                            )}
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <FollowButton id={item.user?._id} showCount={true} stream={item} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="py-4 border-t border-gray-100" hidden={isEmbeded}>
                                <div className="prose prose-sm max-w-none text-gray-600">
                                    <div className="bg-gray-50 rounded-lg p-4">
                                        <div className={`relative ${limitDescription ? 'max-h-20 overflow-hidden' : ''}`}>
                                            <p className="whitespace-pre-wrap leading-relaxed mb-0">
                                                {item.description}
                                            </p>
                                            {limitDescription && item.description.length > 100 && (
                                                <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-gray-50 to-transparent"></div>
                                            )}
                                        </div>
                                        {item.description.length > 100 && (
                                            <button
                                                onClick={() => setLimitDescription(!limitDescription)}
                                                className="text-blue-600 hover:text-blue-700 text-sm font-medium mt-2 focus:outline-none"
                                            >
                                                {limitDescription ? 'Show more' : 'Show less'}
                                            </button>
                                        )}

                                        {item.category && (
                                            <div className="mt-4 pt-4 border-t border-gray-200">
                                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-50 text-blue-700">
                                                    {item.category}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='py-2'>
                                <VideoParts parts={item.parts} callback={objt => setPlaybackUrl(objt.path)} />
                            </div>
                        </div>
                    </div>

                    {/* <div className="flex flex-wrap p-4 bg-gray-500 rounded-lg" hidden={isEmbeded}>

                        <PublicStreams title={' '} list_type='list' exceptions={[item._id]} />

                    </div> */}
                </div>

                <div className="col-md-12 col-sm-12 col-lg-3  m-b-10">
                    <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden h-full">
                        <div className="p-4 border-b border-gray-100 bg-gray-50">
                            <h3 className="font-bold text-lg text-gray-900">Live Chat</h3>
                        </div>
                        <div className="p-0">
                            <Comments streamId={item._id ?? item.id} />
                        </div>
                    </div>
                </div>



            </div>
            <div>
            </div>

        </Loading >
    )
}
